import { NgModule } from '@angular/core';
import {
  RouterModule,
  Routes,
} from '@angular/router';
import { InstallModule } from './modules/install/install.module';

const routes: Routes = [
  {
    path: '',
    loadChildren: (): Promise<typeof InstallModule> => import('./modules/install/install.module')
      .then((module) => module.InstallModule),
  },
  {
    path: '**',
    redirectTo: '/',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
